import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Seuraajat',
  fields: {
    name: 'Nimi:',
    email: 'Sähköposti:',
    phone_number: 'Puhelin:',
    subscribed: 'Tilattu:',
    birthday: 'Syntymäpäivä:',
    location: 'Sijainti:',
    followed: 'Seurasi:',
    lifetime_spent: 'Elinkaariarvo:',
    total_orders: 'Tilauksia yhteensä:',
    google_review: 'Google-arvostelu:',
    loyalty_lifetime: 'Kanta-asiakaspisteet yhteensä:',
    loyalty_points: 'Kanta-asiakaspisteet tänään:',
  },
  labels: {
    yes: 'Kyllä',
    no: 'Ei',
    followed_since_date: '{{date}} alkaen',
  },
  buttons: {
    edit: 'Muokkaa',
    request_data_deletion: 'Pyydä tietojen poistamista',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
  tabs: {
    recent_orders: {
      title: 'Viimeisimmät tilaukset',
      columns: {
        order_id: 'Tunnus',
        items: 'Tuotteet',
        total: 'Kokonaissumma',
        paid_on: 'Maksettu',
        payment_method: 'Maksutapa',
      },
      labels: {
        no_orders: 'Ei vielä tilauksia',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Kortti',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Pankkiveloitus',
        [PaymentMethods.CASH]: 'Käteinen',
        [PaymentMethods.BACS_DEBIT]: 'Pankkiveloitus',
      },
    },
    messages: {
      title: 'Viestit',
      columns: {
        template: 'Malli',
        status: 'Tila',
        opened: 'Avattu',
        clicked: 'Klikattu',
        spam_complaint: 'Roskapostivalitus',
        unsubscribed: 'Tilaus peruutettu',
        sent_at: 'Lähetetty',
      },
      labels: {
        yes: 'Kyllä',
        no: 'Ei',
        not_detected: 'Ei havaittu',
        opened_at: 'Avattu {{date}}',
        clicked_at: 'Klikattu {{date}}',
        complained_at: 'Valitettu {{date}}',
        unsubscribed_at: 'Tilaus peruttu {{date}}',
        no_messages: 'Ei vielä viestejä',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Lähetetty',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Toimitettu',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Epäonnistui',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Tietojen lataaminen epäonnistui',
      },
    },
    balance_history: {
      title: 'Saldohistoria',
      columns: {
        created_at: 'Päivämäärä',
        source: 'Lähde',
        value: 'Pisteet',
        points_expire_at: 'Vanhenee',
      },
      labels: {
        source: {
          welcome_bonus: 'Tervetuliaisbonus',
          google_review_reward: 'Google-arvostelupalkkio',
          reward_loyalty_program_conversion: 'Kanta-asiakasohjelman muuntopalkkio',
          cashback: 'Käteispalautus',
          refund: 'Hyvitys',
          cashback_usage: 'Käteispalautuksen käyttö',
          cashback_usage_refund: 'Käteispalautuksen käytön hyvitys',
          expired_points_void: 'Vanhentuneiden pisteiden mitätöinti',
          mobile_app_signup_bonus: 'Mobiilisovelluksen rekisteröitymisbonus',
        },
        no_operations: 'Ei vielä tapahtumia',
      },
    },
  },
};
